module.exports = __webpack_public_path__ + "img/lx001.6c291d8e.jpg";